import { useEffect, useState } from 'react'
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom'

import { PanelLayout } from '@/app/panel/layout'
import { destroyKeysCache } from '@/config/key-store'
import { useCompanyChange } from '@/contexts/company-context'

export const PanelPage = () => {
  const [isScrollRestorationActive, setIsScrollRestorationActive] =
    useState(true)

  const { pathname } = useLocation()
  useCompanyChange(destroyKeysCache)

  useEffect(() => {
    setIsScrollRestorationActive(
      !(pathname.includes('eventos') && pathname.includes('reembolsos')),
    )
  }, [pathname])

  return (
    <PanelLayout>
      <Outlet />

      {isScrollRestorationActive && <ScrollRestoration />}
    </PanelLayout>
  )
}
